import * as React from 'react';
import { useLayouts } from '../../hooks';
import { RoomTypeFilter, LayoutsCards } from './parts';
import { WidgetLayout } from './parts/WidgetLayout';
import { NotAvailableScreen } from './parts/NotAvailableScreen';
import { PaginationContainer } from './parts/Pagination/PaginationContainer/PaginationContainer';
import { OffersLinks } from './parts/OffersLinks';
import { useTracking } from '../../hooks/useTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Layouts = function Layouts(_ref) {
  var newbuildingId = _ref.newbuildingId,
    houseId = _ref.houseId,
    roomsCountList = _ref.roomsCountList,
    isHouseLayoutsAvailable = _ref.isHouseLayoutsAvailable,
    onHouseFilterReset = _ref.onHouseFilterReset,
    pageTypeJK = _ref.pageTypeJK;
  var _useLayouts = useLayouts({
      newbuildingId: newbuildingId,
      houseId: houseId,
      isHouseLayoutsAvailable: isHouseLayoutsAvailable
    }),
    layouts = _useLayouts.layouts,
    roomType = _useLayouts.roomType,
    onRoomTypeChange = _useLayouts.onRoomTypeChange,
    isLoading = _useLayouts.isLoading,
    pagination = _useLayouts.pagination,
    offersLinks = _useLayouts.offersLinks;
  var _useTracking = useTracking({
      newbuildingId: newbuildingId,
      pageTypeJK: pageTypeJK,
      houseId: houseId
    }),
    trackOfferLinkClick = _useTracking.trackOfferLinkClick;
  var filterRef = React.useRef(null);
  var columnsNumber = React.useMemo(function () {
    return pageTypeJK === 'Normal' ? 3 : 4;
  }, [pageTypeJK]);
  if (!isHouseLayoutsAvailable) {
    return /*#__PURE__*/_jsx(WidgetLayout, {
      children: /*#__PURE__*/_jsx(NotAvailableScreen, {
        onHouseFilterReset: onHouseFilterReset,
        title: "\u041D\u0435\u0442 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043E\u043A \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043A\u043E\u0440\u043F\u0443\u0441\u0430"
      })
    });
  }
  if (layouts.length === 0 && !isLoading) {
    return /*#__PURE__*/_jsxs(WidgetLayout, {
      children: [/*#__PURE__*/_jsx(RoomTypeFilter, {
        roomsCountList: roomsCountList,
        onChange: onRoomTypeChange,
        value: roomType,
        ref: filterRef
      }), /*#__PURE__*/_jsx(NotAvailableScreen, {
        onHouseFilterReset: onHouseFilterReset,
        title: "\u0412 \u044D\u0442\u043E\u043C \u043A\u043E\u0440\u043F\u0443\u0441\u0435 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043E\u0442\xA0\u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430 \u043D\u0435\u0442"
      })]
    });
  }
  return /*#__PURE__*/_jsxs(WidgetLayout, {
    children: [/*#__PURE__*/_jsx(RoomTypeFilter, {
      roomsCountList: roomsCountList,
      onChange: onRoomTypeChange,
      value: roomType,
      ref: filterRef
    }), /*#__PURE__*/_jsx(LayoutsCards, {
      layouts: layouts,
      isLoading: isLoading,
      columnsNumber: columnsNumber,
      trackClick: trackOfferLinkClick
    }), /*#__PURE__*/_jsx(PaginationContainer, {
      cardsRef: filterRef,
      onPageSelect: pagination.onPageChange,
      page: pagination.page,
      lastPage: pagination.lastPage
    }), !isLoading && /*#__PURE__*/_jsx(OffersLinks, {
      linksInfo: offersLinks,
      houseId: houseId,
      roomType: roomType,
      trackClick: trackOfferLinkClick
    })]
  });
};